import MessageModal from "./MessageModal.view";

export default MessageModal;
